import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { SelectorOptionsSync } from "@plansoft-configuration-renderer/framework";
/**
 * In development, sync options between redux and context
 * @private
 * @returns
 */
export function SettingsSync() {
    return (_jsx(Fragment, { children: _jsx(SelectorOptionsSync, {}) }));
}
//# sourceMappingURL=SettingsSync.js.map